import { HttpHeaders } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Location } from '@angular/common';
import {finalize, catchError, throwError, tap, Observable} from "rxjs";
import { HttpService } from "src/app/services/http.service";
import { DocketDocumentInfoResponse, FileInfo } from "src/app/models/docket";
import { EPDSFile } from "../../models/file-upload";
import { FileUploadComponent } from "../file-upload/file-upload.component";
import { UtilService } from "src/app/services/util.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ReplaceDocumentComponent } from "./replace-document/replace-document.components";
import { FileUploadService } from "src/app/services/file-upload.service";
import { CaseDocketService } from "src/app/services/case-docket.service";
import { ProtestInfo } from "src/app/models/protest";
import { UserRole, UserRoleString } from "src/app/models/user";
import { Router } from "@angular/router";
import { StateService } from "src/app/services/state.service";
import {SidebarService} from "../../services/sidebar.service";

export interface DenialDoc {
  doc_Type_Desc: string;
  doc_Type_Id: number;
  accessType: string;
  attachmentType: string;
}

@Component({
    selector: 'app-docket-document-view',
    templateUrl: './docket-document-view.component.html',
    styleUrl: './docket-document-view.component.scss',
    standalone: false
})
export class DocketDocumentViewComponent implements OnInit {
  UserRole: typeof UserRole = UserRole;
  readonly DENIAL_OF_NOTICE_OF_APPEARANCE_DOC_ID = 161;
  readonly DENIAL_OF_REQUEST_TO_INTERVENE_DOC_ID = 160;
  readonly DENIAL_OF_NOTICE_OF_APPEARANCE_ACCESS_TYPE = "agency-rep-access";
  readonly DENIAL_OF_REQUEST_TO_INTERVENE_ACCESS_TYPE = "intervene";

  @ViewChild('fileUpload', { static: false }) fileUpload!: FileUploadComponent;
  loading = false;
  loadingAfterSubmit = false;
  protectedPO: string = '';
  replacingDocumentFileId: number = 0;
  isProtectedEditable: boolean = false;
  isProtestDocumentInfoEditable: boolean = false;
  isUploadDoc: boolean = false;
  docketFileResponse: DocketDocumentInfoResponse = <DocketDocumentInfoResponse>{};
  file_InfoList!: FileInfo[];
  fileInfo!: FileInfo;
  protestInfo: ProtestInfo = <ProtestInfo>{};
  primaryDocuments: FileInfo[] = new Array<FileInfo>();
  associatedDocuments: FileInfo[] = new Array<FileInfo>();
  docketInfo: any;
  documentType!: string;
  uploadedFiles: EPDSFile[] = [];

  showApproveQstn: boolean = false;
  approveQstnText: string = '';
  accessType: string = '';

  fileUploadInProgress = false;
  requiredFileMessage = 'Upload Document (' + this.fileUploadService.udmPdfWordExcelZip + ')';
  requiredFileType = this.fileUploadService.rftPdfWordExcelZip;
  attachAssociatedDocOutput = false;
  isRequestToInterveneQuesNeedsToBeShown: boolean = false;
  isNoticeOfAppearanceQuesNeedsToBeShown: boolean = false;

  showSubmitNewDoc: boolean = false;

  denialDocInfoList: Array<DenialDoc> = [
    { doc_Type_Desc: 'Denial of Notice of Appearance', doc_Type_Id: this.DENIAL_OF_NOTICE_OF_APPEARANCE_DOC_ID, accessType: this.DENIAL_OF_NOTICE_OF_APPEARANCE_ACCESS_TYPE, attachmentType: 'denialOfNoticeOfAppearance' },
    { doc_Type_Desc: 'Denial of Request to Intervene', doc_Type_Id: this.DENIAL_OF_REQUEST_TO_INTERVENE_DOC_ID, accessType: this.DENIAL_OF_REQUEST_TO_INTERVENE_ACCESS_TYPE, attachmentType: 'denialOfNoticeOfIntervene' },
  ];
  documentName: string = '';
  constructor(
    public readonly stateService: StateService,
    private readonly caseDocketService: CaseDocketService,
    private readonly fileUploadService: FileUploadService,
    private readonly dialog: MatDialog,
    public readonly util: UtilService,
    private readonly httpService: HttpService,
    private readonly location: Location,
    private sidebarService: SidebarService,
    private router: Router
  ) {
    const { a_No, originalSubmissionDate, doc_Type_Id, fileAlert, i } = this.location.getState() as {
      a_No: string;
      originalSubmissionDate: string;
      doc_Type_Id: string;
      fileAlert: string;
      i: number;
    };

    this.docketInfo = {
      index: i,
      doc_Type_Id,
      fileAlert: 'Y',
      protestId: a_No,
      submissionDate: originalSubmissionDate,
    };
  }

  ngOnInit(): void {
    this.getDocketFileInfo();
  }

  getDocketFileInfo() {
    this.loading = true;
    const params = this.httpService.createHttpParams(this.docketInfo);
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    this.httpService.Post<DocketDocumentInfoResponse>('/viewcasedocketFileInfo', params, { headers })
      .pipe(
        finalize(() => this.loading = false),
        catchError(err => throwError(() => err))
      )
      .subscribe((response: DocketDocumentInfoResponse | undefined) => {
        if (!response) return;
        this.sidebarService.setNavByUser(this.stateService.user.role_id, response.protestInfo);

        console.log('Docket File Info Response:', response);

        this.file_InfoList = response.file_InfoList;
        this.fileInfo = this.file_InfoList[0];
        this.protestInfo = response.protestInfo;
        this.protectedPO = response.PO;
        this.docketFileResponse = response;

        this.splitFileTypes();
        this.determineAccess();
      });
  }

  splitFileTypes() {
    this.primaryDocuments = this.file_InfoList.filter(fileInfo => fileInfo.file_identifier === 'P');
    this.associatedDocuments = this.file_InfoList.filter(fileInfo => fileInfo.file_identifier !== 'P');

    if (this.file_InfoList[0].filler != null) {
      this.documentName = this.file_InfoList[0].docTypeName.split("_")[0] + this.file_InfoList[0].filler;
    } else {
      this.documentName = this.file_InfoList[0].docTypeName;
    }
  }

  onEPDSFileListChange(epdsFileList: EPDSFile[]): void {
    this.uploadedFiles = epdsFileList;
  }

  onReplaceFromExisting() {
    //show modal to select existing document
    //on selection, set the selected document to primaryDocument
    const dialogRef: MatDialogRef<ReplaceDocumentComponent> = this.dialog.open(ReplaceDocumentComponent, {
      data: { associatedDocuments: this.associatedDocuments },
      width: '415px',
    });

    dialogRef.afterClosed().subscribe(
      result => {
        if(result == 'markAsPrimary'){
          this.displaySuccessDialog(result);
        }
      });
  }

  onDocumentReplace(document: FileInfo, documentType: string) {
    if (this.isUploadDoc) {
      this.fileUpload.fileCancel('P');
    }
    this.documentType = documentType;
    this.isUploadDoc = true;
    this.replacingDocumentFileId = document.file_Id;
  }

  async replaceDoc(fileId: number) {
    const formData = { file_Id: fileId, newValue: '' };
    await this.changeFileAttribute(formData, 'replaceDoc');
  }

  private getTypeOfChangeMessage(typeOfChange: string): string {
    switch (typeOfChange) {
      case 'replaceDoc':
        return 'You have successfully replaced the document.';
      case 'delete':
        return 'You have successfully deleted the file.';
      case 'confidential':
        return 'You have successfully updated the confidential status for this case.';
      case 'markAsPrimary':
        return 'You have successfully marked the document as primary.';
      default:
        return 'You have successfully updated the document.';
    }
  }

  private displaySuccessDialog(typeOfChange: string) {
    const message = this.getTypeOfChangeMessage(typeOfChange);
    this.getDocketFileInfo();
    this.isUploadDoc = false;
    this.loadingAfterSubmit = false;

    this.util.displayDialogMessage('Success', message).subscribe();
  }

  onDocumentDelete(document: FileInfo) {
    this.util.displayDialogMessage('Confirmation', 'Are you sure you want to permanently delete this file?', {
      confirmText: 'Yes',
      confirmButtonColor:"warn",
      cancelText: 'No',
      cancelBtn: true,
      cancelButtonColor:"primary"
    }).subscribe((response) => {
      if (response) {
        const formData = { file_Id: document.file_Id, newValue: 'no-change' };
        this.changeFileAttribute(formData, 'delete');
      }
    });

  }

  async changeFileAttribute(request: {
    file_Id: number,
    newValue: any
  }, typeOfChange: string) {
    this.loadingAfterSubmit = true;
    await this.caseDocketService.changeFileAttribute(request, typeOfChange).pipe(
      finalize(() => { this.loadingAfterSubmit = false }),
      catchError(err => {
        return throwError(err);
      })
    ).subscribe(response => {
      this.displaySuccessDialog(typeOfChange);
    });
  }

  onEdit() {
    this.isProtestDocumentInfoEditable = true;
  }

  onCancel() {
    this.isProtestDocumentInfoEditable = false;
    this.isUploadDoc = false;
  }

  submitFileUpload() {
    if (this.uploadedFiles.length === 0) {
      return;
    }
    this.loadingAfterSubmit = true;
    const allFiles = [
      ...this.uploadedFiles.map(epdsFile => ({ epdsFile, attachmentType: 'intervene' })),
    ];

    this.fileUploadInProgress = true;
    this.fileUploadService.submitFile(allFiles, this.docketInfo.protestId, this.fileUpload).pipe(
      tap(resp => console.log('Response from submitFile:', resp)),
      catchError(err => {
        // console.error('Error in submitFile:', err);
        this.fileUploadInProgress = false;
        this.loadingAfterSubmit = false;
        return throwError(err);
      })
    ).subscribe(resp => {
      console.debug(resp);
      this.replaceDoc(this.replacingDocumentFileId);
    });
  }

  onProtectedEdit() {
    this.isProtectedEditable = true;
  }

  onProtectedSave() {
    let request = {
      file_Id: this.file_InfoList[0].file_Id,
      newValue: this.protectedPO
    };
    this.changeFileAttribute(request, 'confidential');
    this.isProtectedEditable = false;
    this.isProtestDocumentInfoEditable = false;
  }

  onProtectedCancel() {
    this.isProtectedEditable = false;
  }

  openPdf(fileInfo: FileInfo) {
    // this.loading = true;
    const headers = new HttpHeaders({ 'Accept': '*/*' }); // Accept all file types
    const options = { ...headers, observe: 'response' as 'body', responseType: 'arraybuffer' as 'json' };

    window.open(this.util.getBaseURL() + "/epds/downloaddashboardfile?fileId=" + fileInfo.file_Id, '_blank');

    // this.httpService.Get('/downloaddashboardfile?fileId=' + fileInfo.file_Id, options)
    //   .pipe(
    //     finalize(() => {
    //       this.loading = false;
    //     }),
    //     catchError(err => {
    //       return throwError(err);
    //     })
    //   ).subscribe((response: any) => {
    //     if (response) {
    //       const contentType = response.headers.get('Content-Type');
    //       const file = new Blob([response.body], { type: contentType });
          // const file = new File([response.body], fileInfo.fileName, { type: contentType });
          // this.download(file, fileInfo.fileName)
          // const fileURL = URL.createObjectURL(file);

          // if (contentType === 'application/pdf') {
          //   // Open PDF in a new browser tab
          //   const newWindow = window.open(fileURL, '_blank');
          //   if (newWindow) {
          //     newWindow.focus();
          //   } else {
          //     alert('Please allow popups for this website');
          //   }
          // } else {
          //   // Trigger file download for non-PDF files
          //   const anchor = document.createElement('a');
          //   anchor.href = fileURL;
          //   anchor.download = fileInfo.fileName;
          //   anchor.click();
          //   URL.revokeObjectURL(fileURL);
          // }
      //   } else {
      //     alert('No file available to view or download');
      //   }
      // });
  }

  download(data: Blob, filename: string) {
    const link = document.createElement('a');
    const fileURL = URL.createObjectURL(data);

    link.style.visibility = 'hidden';
    link.href = fileURL;
    link.download = filename;
    link.target='_blank';

    document.body.append(link);
    link.click();
    // window.open(fileURL, '_blank')
    // URL.revokeObjectURL(fileURL);
    link.remove();
  }

  respondToAccessType(request: any): Observable<any> {
    this.loading = true;
    const httpParams = this.httpService.createHttpParams(request);
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };
    return this.httpService.Post<any>('/respond-request-to-access', httpParams, options);
  }

  onApprovalYes() {
    this.showSubmitNewDoc = false;
    const request = {
      accessType: this.accessType,
      file_Id: this.file_InfoList[0].file_Id,
      response: 'Y'
    };

    this.respondToAccessType(request).pipe(
      finalize(() => (this.loading = false)),
      catchError(err => throwError(() => err))
    ).subscribe(() => {
      const successText = this.accessType === this.DENIAL_OF_NOTICE_OF_APPEARANCE_ACCESS_TYPE
        ? "You have successfully acknowledged the agency's representative."
        : "You have successfully acknowledged the intervenor.";

      this.util.displayDialogMessage("Success", successText).subscribe(() => {
        const userRolePath = UserRoleString[this.stateService.user.role_id];
        this.router.navigate([`${userRolePath}/case-docketsheet/${this.protestInfo.a_No}`]);
      });
    });
  }

  onApprovalNo() {
    this.showSubmitNewDoc = true;
  }

  onSubmitDenialDoc() {
    this.showSubmitNewDoc = false;
    const request = {
      accessType: this.accessType,
      file_Id: this.file_InfoList[0].file_Id,
      response: 'N'
    };

    this.respondToAccessType(request).pipe(
      finalize(() => { this.loading = false }),
      catchError(err => throwError(() => err))
    ).subscribe(() => {
      const successText = this.accessType === this.DENIAL_OF_NOTICE_OF_APPEARANCE_ACCESS_TYPE
        ? "agency representative"
        : "intervenor's";

      const userRolePath = UserRoleString[this.stateService.user.role_id];
      this.router.navigate([`${userRolePath}/case-docketsheet/${this.protestInfo.a_No}`]);
      this.util.displayDialogMessage("Success", `You have successfully denied ${successText} access to the document.`).subscribe();
    });
  }


  determineAccess() {
    const isGAOUserWithFullAccess = this.util.isGAOUserWithFullAccess(this.protestInfo.viewOnly);
    const isCaseAccessRequestPending = this.file_InfoList[0].case_access_request_status?.trim() === 'P';

    this.isRequestToInterveneQuesNeedsToBeShown =
      isGAOUserWithFullAccess &&
      this.file_InfoList[0].doc_Type_Id === 56 &&
      isCaseAccessRequestPending;

    this.isNoticeOfAppearanceQuesNeedsToBeShown =
      isGAOUserWithFullAccess &&
      this.documentName.trim() === "Notice Of Appearance" &&
      isCaseAccessRequestPending;

    if (this.isRequestToInterveneQuesNeedsToBeShown || this.isNoticeOfAppearanceQuesNeedsToBeShown) {
      const denialDocTypeId = this.isNoticeOfAppearanceQuesNeedsToBeShown ? this.DENIAL_OF_NOTICE_OF_APPEARANCE_DOC_ID : this.DENIAL_OF_REQUEST_TO_INTERVENE_DOC_ID;
      this.denialDocInfoList = this.denialDocInfoList.filter(denialDoc => denialDoc.doc_Type_Id === denialDocTypeId);
      this.approveQstnText = this.isNoticeOfAppearanceQuesNeedsToBeShown
        ? 'Do you want to acknowledge this agency representative?'
        : 'Do you want to approve the request to intervene?';
      this.accessType = this.denialDocInfoList[0].accessType;
      this.showApproveQstn = true;
    } else {
      this.showApproveQstn = false;
    }
  }
}
